import { Pipe, PipeTransform } from '@angular/core';

import { formatIban } from 'app/directives';

/**
 * Use for **read-only, display-only** IBANs — plain text interpolation with no
 * user input and no form control.
 *
 * Groups the IBAN into 4-character blocks for readability, reusing the same
 * `formatIban()` logic as the `stbyIbanInput` directive so there is a single
 * source of truth for IBAN display formatting.
 *
 * For **editable** inputs bound to a form control, use the `stbyIbanInput`
 * directive instead — it keeps the raw value in the control while formatting the DOM display as
 * the user types, and also handles cursor position and keystroke filtering.
 */
@Pipe({
    name: 'stbyIbanFormat',
})
export class IbanFormatPipe implements PipeTransform {
    transform(value: string | null | undefined): string {
        return formatIban(value ?? '');
    }
}
